import React from 'react';
import FormItem from './FormItem/FormItem';
// import styles from './UpsertRoomType.styles';

export default function UpsertRoomType() {
  return <FormItem />;
}
